import React from "react";
import { ChevronRight } from "lucide-react";
import TeacherGlassCard from "./TeacherGlassCard";

export default function TeacherMinutesSection({
  onSelectMinute,
  sortedMinutes,
}) {
  return (
    <div className="space-y-6 animate-fade-in-up">
      <div className="flex justify-between items-center">
        <h3 className="font-bold text-gray-500 text-sm">총 <span className="text-[#354F38]">{sortedMinutes.length}</span>개의 기록</h3>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {sortedMinutes.map((minute) => (
          <TeacherGlassCard key={minute.id} onClick={() => onSelectMinute(minute)} className="p-6 hover:shadow-lg transition-all duration-300 cursor-pointer group flex gap-6 items-start">
            <div className="flex-shrink-0 flex flex-col items-center justify-center bg-white w-16 h-16 rounded-2xl text-[#354F38] shadow-sm border border-gray-100 group-hover:scale-105 transition-transform">
              <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">{minute.date.slice(5, 7)}월</span>
              <span className="text-2xl font-black leading-none">{minute.date.slice(8, 10)}</span>
            </div>
            <div className="flex-1 py-1 min-w-0">
              <div className="flex justify-between items-start mb-1">
                <h4 className="font-black text-lg text-gray-800 group-hover:text-[#354F38] transition-colors truncate">{minute.title}</h4>
                <ChevronRight className="text-gray-300 group-hover:text-[#354F38] transition-colors" size={20} />
              </div>
              <p className="text-sm text-gray-500 line-clamp-2 leading-relaxed mb-3">{minute.content}</p>
              <div className="flex items-center gap-2">
                <div className="flex -space-x-2 overflow-hidden">
                  {[...Array(Math.min(3, minute.attendees ? minute.attendees.split(",").length : 0))].map((_, i) => (
                    <div key={i} className="w-6 h-6 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-[8px] text-gray-500 font-bold">{i + 1}</div>
                  ))}
                </div>
                <span className="text-xs font-bold text-gray-400 ml-1 bg-gray-50 px-2 py-0.5 rounded-lg">{minute.attendees ? `${minute.attendees.split(",").length}명 참석` : "참석자 미상"}</span>
              </div>
            </div>
          </TeacherGlassCard>
        ))}
      </div>
    </div>
  );
}
